import { SECTION5 } from "../../content/copy";
import { Reveal } from "../Reveal";
import { AuthorPhoto } from "../Media";
import { SectionMark, Folio, RegMarks } from "../fx/Marginalia";

export const PrefaceSpread = () => (
  <section className="sec preface bg-a" data-testid="section-preface" data-rail="05">
    <RegMarks />
    <div className="frame">
      <SectionMark n="05" label="PREFAZIONE" />
      <Reveal as="figure" className="pull" data-testid="preface-quote-box">
        <span className="pull-bar" aria-hidden="true" />
        <blockquote className="pull-text serif" data-testid="preface-quote">{SECTION5.quote}</blockquote>
        <figcaption className="pull-cite mono" data-testid="preface-quote-author">{SECTION5.quoteAuthor}</figcaption>
      </Reveal>
      <div className="g12 author-spread" data-testid="author-profile">
        <Reveal className="author-fig" variant="mask">
          <AuthorPhoto />
          <p className="fig-cap mono" aria-hidden="true">
            <span>FIG. 05</span>
            <span>RITRATTO DELL'AUTORE</span>
          </p>
        </Reveal>
        <div className="author-text">
          <span className="author-kicker mono" aria-hidden="true">{"> profilo_autore · verificato"}</span>
          <Reveal as="h3" className="author-name serif" data-testid="author-name">{SECTION5.authorName}</Reveal>
          <Reveal as="p" className="author-bio serif" delay={200} data-testid="author-bio">{SECTION5.authorBio}</Reveal>
        </div>
      </div>
      <Folio n="05" />
    </div>
  </section>
);
